import { Modal, ModalProps } from "antd";
import React, { FC } from "react";
import { JCMSCTAContainer } from "../JCMSCTAContainer";
import { JHTML } from "../JHTML";
import { CMSSection } from "../models";
import './JSectionModal.scss';

export interface JSectionModalProps extends ModalProps {
    section: CMSSection,
    context?: string
}

export const JSectionModal: FC<JSectionModalProps> = props => (
    <Modal
        {...props}
        className={`jsection-modal jsection-modal-context-${props.context || 'generic'}`}
        title={
            <JHTML.SectionTitle html={props.section.title || ''} level={3} />
        }

        footer={
            props.section.cta ? (
                <JCMSCTAContainer cta={props.section.cta} align="right" />
            ) : null
        }
    >
        {props.section.text && <JHTML.Text html={props.section.text || ''} />}
        {
            props.children
        }
    </Modal>
)
